export default __webpack_public_path__ + "exchange-arrows.png";